// extracted by mini-css-extract-plugin
export default {"container":"SubjectsContent_container__kOBOf","list":"SubjectsContent_list__yvOWD","left":"SubjectsContent_left__dSs5c","right":"SubjectsContent_right__0Ss6q"};